import { Box, styled } from '@mui/material';
import { HelixPalette, HelixStyles } from '../../helix';
/**
 * Styled Box for the home bar.
 */
export const HomebarBox = styled(Box)(() => ({
    alignItems: 'center',
    backgroundColor: HelixPalette.teal80,
    borderTopRightRadius: '2.5rem',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between',
    left: 0,
    padding: '1.5rem 0',
    position: 'fixed',
    top: 0,
    width: '72px',
    zIndex: 999,
}));
/**
 * Styled Box for the selected context on a home bar.
 */
export const HomebarContextBox = styled(Box)(() => ({
    backgroundColor: HelixPalette.teal90,
    borderBottomRightRadius: '2.5rem',
    borderTopRightRadius: '2.5rem',
    height: '100%',
    justifyContent: 'space-between',
    left: 0,
    paddingLeft: '72px',
    position: 'fixed',
    top: 0,
    zIndex: 998,
}));
/**
 * Base styles for any home bar item.
 */
const HomebarItem = {
    alignItems: 'center',
    backgroundColor: HelixPalette.teal80,
    border: `2px solid ${HelixPalette.white}`,
    borderRadius: '100%',
    display: 'flex',
    height: '2.5rem',
    justifyContent: 'center',
    width: '2.5rem',
    svg: { fill: HelixPalette.white },
    '&:hover': {
        backgroundColor: HelixPalette.teal05,
        borderColor: HelixPalette.teal05,
        cursor: 'pointer',
        svg: { fill: HelixPalette.teal90 },
        '.MuiAvatar-root': {
            backgroundColor: HelixPalette.teal05,
            span: { color: HelixPalette.teal90 },
        },
    },
    '&:active:focus': {
        backgroundColor: HelixPalette.teal10,
        borderColor: HelixPalette.teal10,
        svg: { fill: HelixPalette.teal90 },
        '.MuiAvatar-root': {
            backgroundColor: HelixPalette.teal10,
            span: { color: HelixPalette.teal90 },
        },
    },
    '&[data-active="true"]': {
        backgroundColor: HelixPalette.white,
        borderColor: HelixPalette.white,
        svg: { fill: HelixPalette.teal90 },
        '.MuiAvatar-root': {
            backgroundColor: HelixPalette.white,
            span: { color: HelixPalette.teal90 },
        },
    },
    '&:focus-visible': {
        backgroundColor: HelixPalette.teal05,
        borderColor: HelixPalette.blue70,
        svg: { fill: HelixPalette.blue70 },
        '.MuiAvatar-root': {
            backgroundColor: HelixPalette.teal05,
            span: { color: HelixPalette.blue70 },
        },
    },
    '&:focus': { outline: 'none' },
};
/**
 * Styled <a /> for a home bar link.
 */
export const HomebarLink = styled('a')(() => (Object.assign(Object.assign({}, HomebarItem), { marginBottom: '2rem' })));
/**
 * Styled <button /> for the logout button.
 */
export const HomebarLogoutButton = styled('button')(() => (Object.assign(Object.assign({}, HelixStyles.style_09), { alignItems: 'center', backgroundColor: 'transparent', border: `2px solid ${HelixPalette.white}`, borderRadius: '6px', color: HelixPalette.white, display: 'flex', padding: '4px 12px', textDecoration: 'none', '&:hover': {
        backgroundColor: HelixPalette.teal80,
        cursor: 'pointer',
    }, '&:active:focus': { backgroundColor: HelixPalette.teal100 }, '&:focus': { outlineColor: HelixPalette.blue70 } })));
/**
 * Styled <a /> for the user profile link.
 */
export const HomebarProfileLink = styled('a')(() => (Object.assign(Object.assign({}, HelixStyles.style_09), { backgroundColor: 'transparent', border: 'none', borderRadius: '0.375rem', color: HelixPalette.white, height: '1.5rem', padding: '0 0.75rem', textDecoration: 'none', '&:hover': {
        color: HelixPalette.neutral05,
        cursor: 'pointer',
        textDecoration: 'underline',
    }, '&:visited': { color: HelixPalette.white }, '&:focus': { outlineColor: HelixPalette.blue70 } })));
/**
 * Styled <button /> for a home bar button.
 */
export const StyledButton = styled('button')(() => (Object.assign(Object.assign({}, HomebarItem), { zIndex: 2 })));
/**
 * Styled div for an current product.
 */
export const CurrentProduct = styled('div')(() => ({
    alignItems: 'center',
    backgroundColor: HelixPalette.teal80,
    border: `2px solid ${HelixPalette.white}`,
    borderRadius: '100%',
    display: 'flex',
    height: '2.5rem',
    justifyContent: 'center',
    marginBottom: '2rem',
    width: '2.5rem',
    svg: { fill: HelixPalette.white },
    '&[data-active="true"]': {
        backgroundColor: HelixPalette.white,
        borderColor: HelixPalette.white,
        svg: { fill: HelixPalette.teal90 },
    },
}));
